/**
 * Application constants
 */

export const PAGE_SIZES = [10, 25, 50, 100] as const;

export const ORDERS_PAGE_SIZES = [10, 25, 50, 100, 200] as const;

export const DEFAULT_ORDERS_PAGE_SIZE = 100;

export const ORDER_STATUSES = [
  "In Store",
  "Breaze Ineligible",
  "Breaze Eligible",
  "InManifest",
  "ConfirmManifest",
  "UnAssigned",
  "Assigned",
  "Decline",
  "Accepted",
  "Collected",
  "At Hub",
  "Pickup Started",
  "Pickup InProgress",
  "Failed",
  "Pickup Completed",
  "Delivery Started",
  "Delivery InProgress",
  "Delivery Completed",
  "Cancelled",
  "Deleted",
  "Shipped By 3rd Party",
  "Created",
  // v4 order rollup statuses (OrderV4.status)
  "Partially Fulfilled",
  "Fulfilled",
] as const;

export const PLATFORMS = ["Shopify", "Woocommerce", "Custom", "External"] as const;

export type OrderStatus = (typeof ORDER_STATUSES)[number];

/**
 * v4 shipment-level statuses (OrderV4Shipment.status/milestone) — a separate
 * vocabulary from the order-level `status` field. Shown on the v4 Orders page's
 * Status dropdown alongside "Breaze Eligible"/"Breaze Ineligible", but filtered
 * on a distinct `shipmentStatus` field.
 */
export const SHIPMENT_STATUSES = [
  "Booked",
  "Collected",
  "At Hub",
  "In Transit",
  "Out for delivery",
  "Delivered",
  "Shipped By 3rd Party",
  "Cancelled",
  "Failed",
  "Collection Failed",
] as const;

export type ShipmentStatus = (typeof SHIPMENT_STATUSES)[number];

// Values match the backend Store model's integration_type enum exactly (case-sensitive
// Mongoose enum validator) — "Woocommerce", not "WooCommerce". Use STORE_TYPE_LABELS for display.
export const STORE_TYPES = ["Custom", "Shopify", "Woocommerce"] as const;

export const STORE_TYPE_LABELS: Record<(typeof STORE_TYPES)[number], string> = {
  Custom: "Custom",
  Shopify: "Shopify",
  Woocommerce: "WooCommerce",
};

export const USER_ROLES = ["Admin", "StoreManager", "User"] as const;
